import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "./Constants";

const ResetPassword = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false); // ✅ controls color

  // ✅ Password validation regex
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset message state
    setResponseMessage("");
    setIsSuccess(false);

    // ✅ Password match check
    if (formData.newPassword !== formData.confirmPassword) {
      setIsSuccess(false);
      setResponseMessage(
        "New password and confirm password do not match."
      );
      return;
    }

    // ✅ Password strength validation
    if (!passwordRegex.test(formData.newPassword)) {
      setIsSuccess(false);
      setResponseMessage(
        "Password must be 8+ characters with uppercase, lowercase, number and special character."
      );
      return;
    }

    try {
      const token = sessionStorage.getItem("token");

      const response = await fetch(`${BASE_URL}reset_password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
        body: new URLSearchParams({
          username: formData.username,
          oldPassword: formData.oldPassword,
          newPassword: formData.newPassword,
          confirmPassword: formData.confirmPassword,
        }),
      });

      const result = await response.json();

      if (!response.ok || !result.status) {
        setIsSuccess(false);
        setResponseMessage(result.error || "Reset password failed.");
        return;
      }

      // ✅ SUCCESS MESSAGE (GREEN)
      setIsSuccess(true);
      setResponseMessage(
        "Password reset successful. Please login again."
      );

      // Logout user
      sessionStorage.clear();

      // Redirect after delay
      setTimeout(() => {
        navigate("/");
      }, 1500);

    } catch (error) {
      setIsSuccess(false);
      setResponseMessage(`Error: ${error.message}`);
    }
  };

  const handleCancel = () => {
    navigate("/");
  };

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left py-5 px-4 px-sm-5">

                <h3 className="text-center">Reset Password</h3>
                <br />

                <form onSubmit={handleSubmit}>

                  {/* Username */}
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Enter Username / Employee Code"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Old Password */}
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      placeholder="Enter Old Password"
                      name="oldPassword"
                      value={formData.oldPassword}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* New Password */}
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      placeholder="Enter New Password"
                      name="newPassword"
                      value={formData.newPassword}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Confirm Password */}
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      placeholder="Confirm New Password"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mt-3 d-grid gap-2">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg"
                    >
                      Reset Password
                    </button>

                    <button
                      type="button"
                      className="btn btn-secondary btn-lg"
                      onClick={handleCancel}
                    >
                      Back to Login
                    </button>
                  </div>

                  {/* ✅ Dynamic Message Color */}
                  {responseMessage && (
                    <div
                      className={`mt-3 text-center ${
                        isSuccess ? "text-success" : "text-danger"
                      }`}
                    >
                      {responseMessage}
                    </div>
                  )}

                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;